import React, { Component } from 'react'
import ReactGA from 'react-ga';
import ModalTop50 from './modal-top-50'

const styles={
    logoPp:{
        'height': '90%',
        'width': '90%'
    },
    logoDkk:{
        'height': '100%',
        'width': '100%'
    }
}

export class Footer extends Component {
    constructor(){
        super();
        const trackingId = "UA-145243581-4"; // PP DCH 2019
        ReactGA.initialize(trackingId);
        
        this.handleRegisterClicked = this.handleRegisterClicked.bind(this);
    }

    handleRegisterClicked(location){
        ReactGA.event({
            category: "Register",
            action: "Clicked",
            label: location
        });
    }

    render() {
        return (
            <div className="footer-section" id="sponsor">
                <div className="container">
                    <div className="footer-newsletter-section">
                        <div className="row justify-content-center">
                            <div className="footer-newsletter-content">
                                <h2>Top 50 Teams</h2>
                                <p>Check your team on the list below</p>
                                <ModalTop50 />
                            </div>
                        </div>
                    </div>

                    <div className="row margin-decrese">
                        <div className="col-xl-4 col-lg-5 col-margin">
                        <div className="single-footer">
                            <div className="footer-title">
                                <a href="http://ppdigitalconstruction.com" target="_blank" rel="noopener noreferrer">
                                    <img src={require("../../assets/image/logo-DCD-2019.png")} alt=""/>
                                </a>
                            </div>
                            <div className="footer-text">
                                <p>Hackathon is part of
                                <br/>Digital Construction Day 2019</p>
                            </div>
                            <ul className="footer-social-list mx-auto justify-content-center">
                                <li>
                                    <a href="https://twitter.com/ptpp_id?lang=en" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/ptpp_id/?hl=en" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-instagram"></i>
                                    </a>
                                </li>
                            </ul>
                            <ul className="footer-social-list mx-auto justify-content-center">
                                <li>
                                    Should you have any questions? Please contact
                                    <br/>
                                    <a href="mailto:info-dch@ptpp.co.id">
                                        <button className="submit-btn" >        
                                            info-dch@ptpp.co.id
                                        </button>
                                    </a>  
                                </li>
                            </ul>
                        </div>
                        </div>
                        <div className="col-lg-2 col-sm-4 col-6 offset-lg-1 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <h6>Powered By</h6>
                                </div>
                                <a href='http://ptpp.co.id' target="_blank" rel="noopener noreferrer">
                                    <img src={require("../../assets/image/pp-logo-blue.jpg")} alt=""style={styles.logoPp}/>
                                </a>
                            </div>
                        </div> 
                        <div className="col-lg-2 col-sm-4 col-6 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <h6>Organized By</h6>
                                </div>
                                {/* <ul className="footer-list"> */}
                                <a href='mailto:info@dkkconsulting.id' target="_blank" rel="noopener noreferrer">
                                    <img src={require("../../assets/logos/DKK.jpeg")} alt=""/>
                                </a>
                                    
                                    {/* <li><img src={require("../../assets/logos/PPRE.png")} alt="" height="80%" width="80%"/></li>
                                    <li><img src={require("../../assets/logos/PPRO.jpg")} alt="" height="80%" width="80%"/></li>
                                    <li><img src={require("../../assets/logos/PPUR.JPG")} alt="" /></li> */}
                                    {/* <li><img src={require("../../assets/logos/logo-11.svg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/logo-8.svg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/logo-1.svg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/logo-3.svg")} alt="" /></li> */}
                                    
                                {/* </ul> */}
                            </div>
                        </div>  
                        <div className="col-lg-2 col-sm-4 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <h6>&nbsp;</h6>
                                </div>
                                <ul className="footer-list">
                                    {/* <li><img src={require("../../assets/logos/PPIN.jpg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/PPEN.png")} alt="" /></li> */}
                                    {/* <li><img src={require("../../assets/logos/logo-2.svg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/logo-12.svg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/logo-4.svg")} alt="" /></li>
                                    <li><img src={require("../../assets/logos/logo-5.svg")} alt="" /></li> */}
                                    
                                </ul>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer
